export default "<p>\r\n  view-request works!\r\n</p>\r\n";